<template>
  <div v-loading="loading">
    <div class="label-tip">{{data.name}}</div>
        <el-table
            :data="dataList"
            stripe
            :header-cell-style="{background:'#e8eaec',color:'#333'}"
            max-height="400px"
            style="width: 100%">
            <el-table-column
                prop="edit_name"
                label="修改人"
                align="center"
                min-width="100">
            </el-table-column>
             <el-table-column
                prop="mtime"
                label="修改时间"
                align="center"
                min-width="100">
            </el-table-column>
             <el-table-column
                prop="old_data"
                label="修改前"
                align="center"
                min-width="100">
            </el-table-column>
             <el-table-column
                prop="new_data"
                label="修改后"
                align="center"
                min-width="100">
            </el-table-column>
        </el-table>
  </div>
</template>

<script>
import API from '@/api/workOrder/conf'
export default {
    name: 'CapacityHistoryModal',
    props: [ 'data' ],
    data() {
        return {
            dataList: [],
        }
    },
    created() {
        this.getList()
    },
    methods: {
        async getList() {
            try {
                this.loading = true;
                const { data } = await API.getProductionCapacityConfigHistoryList({
                    id: this.data.id,
                });
                this.dataList = data
            } catch (error) {
                this.$message.error(error.info);
            }finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.label-tip {
    font-size: 14px;
    color: #9c9c9c;
    position: absolute;
    top: 11px;
    left: 114px;
}

</style>